import React, { useState } from 'react';

import { V1Amount } from '@/api/clients/ohip';
import { Flex } from '@/box';
import { CurrencyPreview, useCurrencyPreview } from '@/currency-preview';
import { useTranslation } from '@/i18n';
import { BodySmall, Caption } from '@/ui/typography';

import { MembershipBenefitsModal } from './MembershipBenefitsModal';
import { MembershipSaving } from './MembershipSaving';

interface MembershipRateContentProps {
  pricePerNight?: V1Amount;
  membershipPrice: V1Amount;
  saving: V1Amount;
  description: string | React.ReactNode;
  destinationFeeSummary?: string;
}

export const MembershipRateContent = ({
  pricePerNight,
  membershipPrice,
  saving,
  description,
  destinationFeeSummary,
}: MembershipRateContentProps) => {
  const { t } = useTranslation('bookingMembership');
  const pricePerNightWithPreview = useCurrencyPreview({
    amount: pricePerNight,
  });
  const membershipPriceWithPreview = useCurrencyPreview({
    amount: membershipPrice,
  });

  const [isMembershipBenefitsModalOpen, setIsMembershipBenefitsModalOpen] =
    useState(false);

  return (
    <Flex flexDirection="column" gap="16px">
      {pricePerNight && (
        <BodySmall color="secondary300">
          {t('roomRate.pricePerNight', {
            pricePerNight: pricePerNightWithPreview,
          })}
        </BodySmall>
      )}
      {destinationFeeSummary && (
        <Caption color="secondary300">{destinationFeeSummary}</Caption>
      )}
      <BodySmall>{description}</BodySmall>
      <MembershipSaving
        saving={<CurrencyPreview amount={saving} />}
        css={{ marginTop: '6px' }}
      />
      <BodySmall>{t('roomRate.info')}</BodySmall>
      <BodySmall css={{ fontWeight: 'bold' }}>
        <a
          onClick={() => setIsMembershipBenefitsModalOpen(true)}
          rel="noreferrer"
          style={{ cursor: 'pointer' }}
        >
          {t('benefits')}
        </a>
      </BodySmall>
      <MembershipBenefitsModal
        isOpen={isMembershipBenefitsModalOpen}
        onClose={() => setIsMembershipBenefitsModalOpen(false)}
      />
    </Flex>
  );
};
